import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import FlashcardsPage from './pages/FlashcardsPage';
import FlashcardDetailPage from './pages/FlashcardDetailPage';
import CoursParticuliersPage from './pages/CoursParticuliersPage';
import RessourcesPage from './pages/RessourcesPage';
import CartPage from './pages/CartPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import MentionsLegales from './pages/legal/MentionsLegales';
import CGV from './pages/legal/CGV';
import Confidentialite from './pages/legal/Confidentialite';
import BacSubjectsPage from './pages/BacSubjectsPage';
import AdminPage from './pages/admin/AdminPage';
import CookieConsent from './components/CookieConsent';

const App = () => {
  return (
    <>
      <Helmet>
        {/* Balises meta par défaut */}
        <html lang="fr" />
        <title>Comprendre les SES | Cours, Flashcards et Ressources de Révision</title>
        <meta name="description" content="Réussissez votre bac SES avec nos cours particuliers, flashcards et ressources gratuites. Méthodes efficaces pour réviser les Sciences Économiques et Sociales." />
        <meta name="keywords" content="SES, sciences économiques et sociales, bac, révisions, cours particuliers, flashcards, ressources gratuites, économie, sociologie, terminale, première, seconde, préparation bac" />
        <meta name="author" content="Brandon et Marion - Comprendre les SES" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Comprendre les SES | Cours, Flashcards et Ressources de Révision" />
        <meta property="og:description" content="Réussissez votre bac SES avec nos cours particuliers, flashcards et ressources gratuites." />
        <meta property="og:url" content="https://cours-ses.fr" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.appspot.com/o/images%2Fphoto%20profil%20SES.jpeg?alt=media&token=b2a39978-10b6-4889-9a79-d50e6220dbf5" />
        <meta property="og:site_name" content="Comprendre les SES" />
        <meta property="og:locale" content="fr_FR" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@ComprendreSES" />
        <meta name="twitter:creator" content="@ComprendreSES" />
        
        {/* Autres meta tags importants */}
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="bingbot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        
        {/* PWA */}
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Comprendre les SES" />
        <meta name="application-name" content="Comprendre les SES" />
        <meta name="theme-color" content="#9a6ebd" />
        
        {/* Liens canoniques et alternates */}
        <link rel="canonical" href="https://cours-ses.fr" />
        <link rel="alternate" href="https://cours-ses.fr" hreflang="fr-fr" />
        <link rel="alternate" href="https://cours-ses.fr" hreflang="x-default" />
      </Helmet>

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/flashcards" element={<FlashcardsPage />} />
        <Route path="/flashcards/:id" element={<FlashcardDetailPage />} />
        <Route path="/cours-particuliers" element={<CoursParticuliersPage />} />
        <Route path="/ressources" element={<RessourcesPage />} />
        <Route path="/sujets-bac" element={<BacSubjectsPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/confirmation" element={<OrderConfirmationPage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <CookieConsent />
    </>
  );
};

export default App;